import graphql__2bd885591818aeb208f5 from "./__generated__/ContributionsListManagerQuery.graphql.js";import { graphql } from "react-relay";
import AppQueryRenderer from "../../AppQueryRenderer";

import { CONTRIBUTIONS_BATCH_SIZE } from "./ContributionsList";
import { COMMENTS_BATCH_SIZE } from "../../Comments/CommentsList";
import { BoxSpinner } from "../../Utils/Spinner";
import ContributionsListWithoutNavigation from "./ContributionsListWithoutNavigation";
import ContributionsListWithNavigation from "./ContributionsListWithNavigation";

const ContributionsListManager = ({ participativeModuleId }) => {
  const contributionsCount = CONTRIBUTIONS_BATCH_SIZE;
  const commentsCount = COMMENTS_BATCH_SIZE;

  return (
    <AppQueryRenderer
      query={ContributionsListManagerQuery}
      variables={{ participativeModuleId, contributionsCount, commentsCount }}
      loader={<BoxSpinner />}
    >
      {({ participativeModule }) => {
        return participativeModule.visualization.enableContributionsNavigation ? (
          <ContributionsListWithNavigation participativeModule={participativeModule} />
        ) : (
          <ContributionsListWithoutNavigation participativeModule={participativeModule} />
        );
      }}
    </AppQueryRenderer>
  );
};

const ContributionsListManagerQuery = graphql__2bd885591818aeb208f5;

export default ContributionsListManager;
